import { render, staticRenderFns } from "./DialogPlanObiettivo.vue?vue&type=template&id=844109c4&scoped=true&"
import script from "./DialogPlanObiettivo.vue?vue&type=script&lang=js&"
export * from "./DialogPlanObiettivo.vue?vue&type=script&lang=js&"
import style0 from "./DialogPlanObiettivo.vue?vue&type=style&index=0&id=844109c4&lang=scss&scoped=true&"
import style1 from "./DialogPlanObiettivo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844109c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('844109c4')) {
      api.createRecord('844109c4', component.options)
    } else {
      api.reload('844109c4', component.options)
    }
    module.hot.accept("./DialogPlanObiettivo.vue?vue&type=template&id=844109c4&scoped=true&", function () {
      api.rerender('844109c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/DialogPlanObiettivo.vue"
export default component.exports